import constants from "../../../../../appConstants";
import { mergeUserConfig } from "../../../../dataGrid/gridUtilities";
import { getPendingStopStatus } from "../../utils/utils";
import { PICKUP_STATUS } from "../constants";
import { getPickupStatus, getPickupStatusTypeIcon } from "../utils/pickupStatusTypeIcon";

const getDriverMapConfig = (userConfig) => {
  const defaultConfig = {
    title: constants.mapName.DispatchMap,
    toggles: {
      isMapLegendEnabled: false,
      isRouteAnimationEnabled: true,
      isShowAllDriversEnabled: true,
    },
  };
  return mergeUserConfig({
    defaultConfig,
    userConfig,
  });
};

const isDriverDelayed = (route) => {
  return route.stops.findIndex((stop) => isDelayStop(stop)) > -1;
};

const isDelayStop = (stop) => {
  return (
    !stop?.isStopCompleted &&
    getPendingStopStatus(stop) === constants.STOP_STATUS.DELAYED
  );
};

const getStopMarkerColors = ({ theme, stop, routeColor }) => {
  if (isDelayStop(stop)) {
    return {
      color: theme.delayedStopMarkerColor,
      borderColor: theme.delayedStopMarkerColor,
      markerTextColor: theme.routeMapColorPalette.MarkerTextColor,
    };
  }
  return {
    color: routeColor,
    borderColor: theme.routeMapColorPalette.MarkerBorderColor,
    markerTextColor: theme.routeMapColorPalette.MarkerTextColor,
  };
};

const isPickupOnMapActive = (selectedPickups, currentPickupId) => {
  return selectedPickups.find((pickup) => pickup.pickupId === currentPickupId);
};

const getIconColor = ({ pickup, theme, terminalOffset }) => {
  const status = getPickupStatus(pickup, terminalOffset);

  switch (status) {
    case PICKUP_STATUS.missed:
    case PICKUP_STATUS.voided:
      return theme.missedPickupIcon;
    case PICKUP_STATUS.completed:
      return theme.palette.primary.main;
    case PICKUP_STATUS.notCompleted:
      return theme.iconColor;
    case PICKUP_STATUS.newPickup:
    case PICKUP_STATUS.unacknowledged:
    case PICKUP_STATUS.dailyPickup:
    case PICKUP_STATUS.future:
    default:
      return theme.warningColor;
  }
};

const getPickupStopData = (routesList, pickup) => {
  const pickupRoute = routesList.find(
    (route) => route.routeId === pickup.routeId
  );

  if (pickup?.driverId && pickupRoute) {
    const stopData =
      pickupRoute.stops.find(
        (stop) => stop.pickupId?.toLowerCase() === pickup.pickupId.toLowerCase()
      ) ?? null;
    return {
      stopColor: pickupRoute.color,
      stopData: {
        ...stopData,
        driverName: pickup.driverName,
        driverNumber: pickup.driverNumber,
        driverId: pickup.driverId,
      },
    };
  } else {
    return {
      stopColor: null,
      stopData: null,
    };
  }
};

const isPickupDriverExistInGrid = ({
  currentActiveRoutes,
  driverId,
  routeId,
}) => {
  return currentActiveRoutes?.find(
    (driver) => driver.driverId === driverId && driver.routeId === routeId
  );
};

const getMarkerComponent = ({ terminalOffset, pickup, theme }) => {
  const params = {
    theme,
    status: getPickupStatus(pickup,terminalOffset),
    size: 20,
  };
  const markerInfo = getPickupStatusTypeIcon(params);

  return markerInfo.marker;
};

const isPickupUnassigned = (selectedPickupsList, pickupId) => {
  return !selectedPickupsList?.find(
    (pickup) => pickup.pickupId?.toLowerCase() === pickupId?.toLowerCase()
  )?.driverId;
};

const checkPickupExists = ({
  filteredPickups,
  selectedPickupsList,
  pickupId,
}) => {
  const isPickupIdExistInMap = filteredPickups.find(
    (pickup) => pickup.pickupId === pickupId
  );
  return isPickupIdExistInMap && selectedPickupsList.length > 0;
};

const getUnassignMarkerInfo = ({
  pickup,
  isPickupActive,
  theme,
  terminalOffset,
}) => {
  const iconColor = getIconColor({ pickup, theme, terminalOffset });
  return {
    pickup,
    backgroundColor: isPickupActive ? theme.white : iconColor,
    borderColor: isPickupActive ? iconColor : theme.white,
    terminalOffset,
    theme,
  };
};

const getPickupsRouteData = (routesList, eventData) => {
  if (eventData.success) {
    return routesList.find((r) => r.routeId === eventData.routeId);
  }
  return routesList.find(
    (r) => r.driverId.toLowerCase() === eventData.driverId.toLowerCase()
  );
};

export {
  getDriverMapConfig,
  isDriverDelayed,
  isDelayStop,
  getStopMarkerColors,
  isPickupOnMapActive,
  getIconColor,
  getPickupStopData,
  isPickupDriverExistInGrid,
  getMarkerComponent,
  isPickupUnassigned,
  checkPickupExists,
  getUnassignMarkerInfo,
  getPickupsRouteData,
};
